import { SVGProps } from 'react';
import { JSX } from 'react/jsx-runtime';

export default function ChevronBack(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15 18C15 18 9 13.5811 9 12C9 10.4188 15 6 15 6"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
